export class TicketConnection{
    id : number;
    ticketId : number;
    connectedTicketId : number;

    createdBy : number; 
    updatedBy : number; 
    deletedBy : number; 
}